// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__1tm_G","info":"Note_info__2MFNd","note":"Note_note__12RhB","actions":"Note_actions__6Q3_3"};